<template>
  <section class="text-gray-600 body-font">
    <div class="container px-5 py-24 mx-auto">
      <div class="flex flex-wrap -m-4">
        <div class="xl:w-1/3 md:w-1/2 p-4" id="feature-card">
          <div class="border border-gray-600 p-6">
            <div
              class="
                w-16
                h-16
                inline-flex
                items-center
                justify-center
                rounded-full
                bg-gray-100
                text-black
                mb-4
              "
            >
              <i class="fa fa-bell-o text-2xl" aria-hidden="true"></i>
            </div>
            <h2 class="text-lg text-gray-900 font-bold title-font mb-2">
              Manage Tasks
            </h2>
            <p class="leading-relaxed text-base">
              With Trackee you can easily manage your task, report your task
              progress and control productivity
            </p>
          </div>
        </div>
        <div class="xl:w-1/3 md:w-1/2 p-4" id="feature-card">
          <div class="border border-gray-600 p-6">
            <div
              class="
                w-16
                h-16
                inline-flex
                items-center
                justify-center
                rounded-full
                bg-gray-100
                text-black
                mb-4
              "
            >
              <i class="fa fa-cog text-2xl" aria-hidden="true"></i>
            </div>
            <h2 class="text-lg text-gray-900 font-bold title-font mb-2">
              Increase Productivity
            </h2>
            <p class="leading-relaxed text-base">
              Trackee helps you to track your progress and measure the time
              spent in your task or company task.
            </p>
          </div>
        </div>
        <div class="xl:w-1/3 md:w-1/2 p-4" id="feature-card">
          <div class="border border-gray-600 p-6">
            <div
              class="
                w-16
                h-16
                inline-flex
                items-center
                justify-center
                rounded-full
                bg-gray-100
                text-black
                mb-4
              "
            >
              <i class="fa fa-user-plus text-2xl" aria-hidden="true"></i>
            </div>
            <h2 class="text-lg text-gray-900 font-bold title-font mb-2">
              Share Knowledge
            </h2>
            <p class="leading-relaxed text-base">
              You can share some articles or guides on how you manage the task
              you work on using trackee
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "PricingList",
};
</script>
<style>
/* #feature-card:hover{
    background: #0c0e2d;
    color: white;
    width: 20rem;
} */
</style>